import { graphql, useStaticQuery } from 'gatsby';

export const usePodcastLogo = () => {
  const data = useStaticQuery(graphql`
    query {
      courierWeekly: file(
        relativePath: { eq: "assets/svg/courier-weekly.svg" }
      ) {
        ...LocalSvgFragment
      }
      courierWorkshopWeekly: file(
        relativePath: { eq: "assets/svg/courier-workshop-weekly.svg" }
      ) {
        ...LocalSvgFragment
      }
    }
  `);

  return data;
};
